import React, { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import OpportunityDetail from "./pages/OpportunityDetail";
import Events from "./pages/Events";
import Admin from "./pages/Admin";

function App() {
  const [theme, setTheme] = useState("dark");

  useEffect(() => {
    const saved = localStorage.getItem("bm-theme") || "dark";
    setTheme(saved);
  }, []);
  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem("bm-theme", theme);
  }, [theme]);

  const toggleTheme = () => setTheme((t) => (t === "dark" ? "light" : "dark"));

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Events theme={theme} toggleTheme={toggleTheme} />} />
        <Route path="/funding" element={<Home theme={theme} toggleTheme={toggleTheme} />} />
        <Route
          path="/o/:id"
          element={<OpportunityDetail theme={theme} toggleTheme={toggleTheme} />}
        />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
